import { render, staticRenderFns } from "./AssociationArticles.vue?vue&type=template&id=1e58101c&scoped=true"
import script from "./AssociationArticles.vue?vue&type=script&lang=js"
export * from "./AssociationArticles.vue?vue&type=script&lang=js"
import style0 from "./AssociationArticles.vue?vue&type=style&index=0&id=1e58101c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e58101c",
  null
  
)

export default component.exports